/* eslint-disable max-len */
import React from 'react'

export default function SenderIcon() {
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M24.5 12.5001C24.5 19.127 19.1275 24.5 12.5001 24.5C5.8729 24.5 0.5 19.127 0.5 12.5001C0.5 5.8726 5.87289 0.5 12.5001 0.5C19.1276 0.5 24.5 5.87249 24.5 12.5001Z"
        fill="#00CACD"
        fillOpacity="0.1"
        stroke="#00CACD"
      />
      <path d="M9 13H18.125" stroke="#00CACD" strokeWidth="2" />
      <path d="M14.4746 16.5L18.1246 13L14.4746 9.5" stroke="#00CACD" strokeWidth="2" />
      <circle cx="6" cy="13" r="2" fill="#00CACD" />
    </svg>
  )
}
